import React from "react";

// Placeholder for "nothing here yet" areas (no rows, no selection, ...).
const EmptyState = ({ icon = "pi-inbox", title, message, action, compact = false }) => (
  <div className={`ex-empty-state${compact ? " is-compact" : ""}`}>
    <span className="ex-empty-state-icon" aria-hidden="true"><i className={`pi ${icon}`} /></span>
    {title && <div className="ex-empty-state-title">{title}</div>}
    {message && <div className="ex-empty-state-message">{message}</div>}
    {action && <div className="ex-empty-state-action">{action}</div>}
  </div>
);

export default EmptyState;
